import React from 'react';
import { Notifier } from '@airbrake/browser';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.airbrake = new Notifier({
      projectId: 468831,
      projectKey: '9f639c23e33d7070b39d0e71dde6fa8b',
      environment: process.env.NODE_ENV || 'development',
    });
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    
    // Send error to Airbrake
    if (process.env.NODE_ENV === 'production') {
      this.airbrake.notify({
        error: error,
        params: {
          info: info,
          user: this?.props?.user,
      }
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;